import React from "react";
import { BrowserRouter, Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import Header from "./header/Header";
import Footer from "./footer/Footer";
import ScrollToTop from "./ScrollToTop";
import ScrollToTopButton from "./ScrollToTopButton";
import AgeGate from "./age-gate/AgeGate";

import LandingPage from "./landing/LandingPage";
import TheFatBastards from "./the-fat-bastards/TheFatBastards";
import FatInspiration from "./fat-inspiration/FatInspiration";
import RestaurantContainerV3 from "./restaurantsV3/RestaurantContainer";
import RestaurantDetail from "./restaurants/RestaurantDetail";
import RecipeDetail from "./recipes/RecipeDetail";
import WineDetail from "./wines/WineDetail";
import Register from "./register/Register";
import ContactUs from "./contact-us/ContactUs";
import Success from "./forms/Success";
import tandc from "./tandc";
import NotFoundPage from "./404NotFound";
import WhereToBuy from "./wines/WhereToBuy";
import SignUp from "./Signup/SignUp";
import SubscribeSuccessful from "./Signup/SubscribeSuccessful";

const Layout = withRouter(({ location, children }) => {
    const hideChromeRoutes = ["/sign-up", "/sign-up/success"]; // add more routes if needed
    const hideChrome = hideChromeRoutes.includes(location.pathname);

    return (
        <>
            {!hideChrome && <Header />}
            {children}
            {!hideChrome && <Footer />}
        </>
    );
});

const App = () => {
    return (
        <React.Fragment>
            <BrowserRouter>
                <ScrollToTop>
                    <AgeGate />

                    <Layout>
                        <Switch>
                            {/* old link redirects */}
                            <Redirect from="/pages/the_fat_bastards.php" to="/the-fat-bastards" />
                            <Redirect from="/pages/fbinspiration/inspiration.php" to="/fat-inspirations" />
                            <Redirect from="/pages/meet_mr_b.php" to="/" />
                            <Redirect from="/pages/live_large.php" to="/" />

                            <Route path="/" exact component={LandingPage} />
                            <Route path="/sign-up" exact component={SignUp} />
                            <Route path="/sign-up/success" exact component={SubscribeSuccessful} />

                            <Route path="/the-fat-bastards" exact component={TheFatBastards} />
                            <Route path="/the-fat-bastards/:slug" exact component={WineDetail} />
                            <Route path="/fat-inspirations" exact component={FatInspiration} />
                            <Route path="/fat-inspirations/:id" exact component={RecipeDetail} />

                            <Route path="/vib/register" exact component={Register} />
                            <Route path="/restaurants" exact component={RestaurantContainerV3} />
                            <Route path="/vib/restaurants" exact component={RestaurantContainerV3} />
                            <Route path="/restaurants/:id" exact component={RestaurantDetail} />

                            <Route path="/contact-us" exact component={ContactUs} />
                            <Route path="/thank-you" exact component={Success} />
                            <Route path="/terms-and-conditions" exact component={tandc} />
                            <Route path="/where-to-buy" exact component={WhereToBuy} />

                            <Route path="/404" component={NotFoundPage} />
                            <Redirect to="/404" />
                        </Switch>

                        <ScrollToTopButton />
                    </Layout>
                </ScrollToTop>
            </BrowserRouter>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({ isVerified: state.isVerified });
export default connect(mapStateToProps)(App);
